module.exports = __webpack_public_path__ + "img/registeruser.156fe1d6.png";